import React, { ReactNode, useEffect, useState } from 'react';
import { Wrapper } from './ResolutionSimulatorWrapper.styles';
import { useAppStore } from 'src/context/AppContext';
import { Resolution } from 'src/types/ViewModel/Resolution';

type Props = {
    children: ReactNode;
};

const ResolutionSimulatorWrapper: React.FC<Props> = (props: any) => {
    const { selectedResolution, setSelectedResolution } = useAppStore();
    const sessionStorageResolution = JSON.parse(sessionStorage.getItem('selectedResolution'));
    const [activeResolution, setActiveResolution] = useState<Resolution>(null);

    useEffect(() => {
        if (sessionStorageResolution) {
            setActiveResolution(sessionStorageResolution);
        } else if (selectedResolution) {
            setActiveResolution(selectedResolution);
        } else {
            setActiveResolution(null);
        }
    }, [sessionStorageResolution, selectedResolution]);

    React.useEffect(() => {
        const handleResize = () => {
            const newWidth = window.innerWidth;
            const newHeight = window.innerHeight;
            setSelectedResolution({ width: newWidth, height: newHeight, isDefault: false });
        };

        window.addEventListener('resize', handleResize);

        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, [setSelectedResolution]);

    return (
        <Wrapper width={activeResolution?.width} height={activeResolution?.height}>
            {props.children}
        </Wrapper>
    );
};

export default ResolutionSimulatorWrapper;
